import styled from 'styled-components';

const StyledEducationNumber = styled.div`
  .number {
    position: relative;
    height: 66px;
    width: 66px;

    .number__content-container {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      .number__content {
        color: white;
        text-align: center;
        font-size: 36px;
      }
    }

    .number__shape {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      clip-path: polygon(12px 0, 100% 0, 100% 100%, 0 100%, 0 12px);
    }

    .number__clipped {
      height: 100%;
    }
  }
`;

export default StyledEducationNumber;
